import rawCatalogue from "./data/indicator-catalogue.json";
import type { IndicatorCatalogue } from "./types";

export const indicatorCatalogue = rawCatalogue as IndicatorCatalogue;

export const dimensions = Array.from(
  new Map(
    indicatorCatalogue.indicators.map((indicator) => [
      indicator.indicatorId.slice(0, 2),
      indicator.dimension,
    ]),
  ).entries(),
).map(([code, label]) => ({ code, label }));
